module.exports = __webpack_public_path__ + "assets/img/tjldx.77676352.png";